import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageValidatorService {
  async validateImage(file: File): Promise<boolean> {
    const arrayBuffer = await this.readFileAsArrayBuffer(file);
    const uint8Array = new Uint8Array(arrayBuffer);
    if (this.isJpeg(uint8Array)) {
      return true;
    } else {
      return false;
    }
  }

  async readFileAsArrayBuffer(file: File): Promise<ArrayBuffer> {
    return new Promise<ArrayBuffer>((resolve, reject) => {
      const fileReader = new FileReader();

      fileReader.onloadend = () => {
        const arrayBuffer = fileReader.result as ArrayBuffer | null;
        if (arrayBuffer) {
          resolve(arrayBuffer);
        } else {
          reject(new Error('El resultado de FileReader es nulo'));
        }
      };

      fileReader.onerror = () => {
        const frError = fileReader.error;
        if (frError instanceof Error) {
          reject(frError);
        } else {
          reject(new Error(`Error leyendo el archivo`));
        }
      };

      fileReader.readAsArrayBuffer(file);
    });
  }

  isJpeg(uint8Array: Uint8Array): boolean {
    if (uint8Array.length < 2) {
      return false;
    }
    return uint8Array[0] === 0xff && uint8Array[1] === 0xd8;
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result as string | null;
        if (result) {
          resolve(result.split(',')[1]);
        } else {
          reject(new Error('El resultado de FileReader es nulo'));
        }
      };

      reader.onerror = () => {
        const frError = reader.error;
        if (frError instanceof Error) {
          reject(frError);
        } else {
          reject(new Error(`Error convirtiendo archivo a Base64`));
        }
      };

      reader.readAsDataURL(file);
    });
  }
}
